/** استخراج هيكل تنظيمي (معرفات) من organizationalAccess لملء الفلاتر تلقائياً ضمن نطاق المستخدم */
export const normalizeOrgScope = (access) => {
  if (!access || typeof access !== 'object') return null;
  const id = (key) => access[key] ?? access[key.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '')];
  const countryId = id('countryId') ?? id('country_id');
  const regionId = id('regionId') ?? id('region_id');
  const academyId = id('academyId') ?? id('academy_id');
  const districtId = id('districtId') ?? id('district_id');
  const institutionId = id('institutionId') ?? id('institution_id');
  const departmentId = id('departmentId') ?? id('department_id');
  const scope = {
    countryId: countryId != null && countryId !== '' ? String(countryId) : '',
    regionId: regionId != null && regionId !== '' ? String(regionId) : '',
    academyId: academyId != null && academyId !== '' ? String(academyId) : '',
    districtId: districtId != null && districtId !== '' ? String(districtId) : '',
    institutionId: institutionId != null && institutionId !== '' ? String(institutionId) : '',
    departmentId: departmentId != null && departmentId !== '' ? String(departmentId) : ''
  };
  const hasAny = Object.values(scope).some((v) => v !== '' && v != null);
  return hasAny ? scope : null;
};

/** استخراج أسماء الهيكل من organizationalAccess (عندما يعيد الـ API أسماء فقط للمستخدمين دون الأدمن) */
export const normalizeOrgScopeNames = (access) => {
  if (!access || typeof access !== 'object') return null;
  const n = (camel, snake) => access[camel] ?? access[snake] ?? '';
  const names = {
    countryName: n('countryName', 'country_name'),
    regionName: n('regionName', 'region_name'),
    academyName: n('academyName', 'academy_name'),
    districtName: n('districtName', 'district_name'),
    institutionName: n('institutionName', 'institution_name'),
    departmentName: n('departmentName', 'department_name')
  };
  const hasAny = Object.values(names).some((v) => v !== '' && v != null);
  return hasAny ? names : null;
};

export const emptyOrgFilters = () => ({
  countryId: '',
  regionId: '',
  academyId: '',
  districtId: '',
  institutionId: '',
  departmentId: ''
});
